<template>
  <div class="progress-bar">
    <div class="progress-bar-fill" :style="{ width: completed + '%' }">
      <span class="progress-bar-label">{{ completed }}%</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Progressbar",
  props: {
    completed: {
      type: Number,
      required: true,
      validator: value => value >= 0 && value <= 100
    }
  }
};
</script>

<style>
.progress-bar {
  width: 100%;
  height: 20px;
  border-radius: var(--radius-md);
  background: var(--surface-2);
  border: 1px solid var(--line);
  overflow: hidden;
  position: relative;
}

.progress-bar-fill {
  height: 100%;
  background: var(--grad-accent);
  transition: width 1s cubic-bezier(0.25, 0.1, 0.25, 1);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.progress-bar-label {
  color: #fff;
  font-weight: 600;
  font-size: var(--fs-xs);
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.progress-bar-fill:hover .progress-bar-label {
  opacity: 1;
}
</style>
